import { z } from 'zod';

export const productSchema = z.object({
  id: z.string().uuid(),
  site_id: z.string().uuid(),
  name: z.string().min(1),
  slug: z.string().min(1),
  description: z.string().optional(),
  price: z.number().min(0),
  currency: z.string().default('IRR'),
  images: z.array(z.string().uuid()).default([]),
  category_id: z.string().uuid().nullable(),
  is_active: z.boolean().default(true),
  stock: z.number().int().min(0).default(0),
  metadata: z.record(z.unknown()).default({}),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type Product = z.infer<typeof productSchema>;

export const categorySchema = z.object({
  id: z.string().uuid(),
  site_id: z.string().uuid(),
  name: z.string().min(1),
  slug: z.string().min(1),
  description: z.string().optional(),
  parent_id: z.string().uuid().nullable(),
  image_url: z.string().optional(),
  icon: z.string().optional(),
  order: z.number().int().default(0),
  is_active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type Category = z.infer<typeof categorySchema>;

export const currencySchema = z.object({
  id: z.string().uuid(),
  site_id: z.string().uuid(),
  code: z.string().min(3).max(3),
  name: z.string().min(1),
  symbol: z.string().min(1),
  symbol_position: z.enum(['left', 'right', 'left_space', 'right_space']).default('left'),
  decimal_separator: z.string().default('.'),
  thousand_separator: z.string().default(','),
  decimal_places: z.number().int().min(0).max(6).default(2),
  exchange_rate: z.number().min(0).default(1.0),
  is_default: z.boolean().default(false),
  is_active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type Currency = z.infer<typeof currencySchema>;

export const measurementUnitSchema = z.object({
  id: z.string().uuid(),
  site_id: z.string().uuid(),
  unit_type: z.enum(['weight', 'length', 'area', 'volume', 'product']),
  name: z.string().min(1),
  symbol: z.string().min(1),
  base_unit_id: z.string().uuid().nullable(),
  conversion_factor: z.number().min(0).default(1.0),
  is_default: z.boolean().default(false),
  is_active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type MeasurementUnit = z.infer<typeof measurementUnitSchema>;
